export default "__VITE_ASSET__$fJcOmkl__"